import React, { useState, useEffect } from "react";

var INVOLVEMENT_OPTIONS = [
  { value: "all",               label: "All Transactions",    icon: "⊞" },
  { value: "collected_by_me",   label: "Collected by Me",     icon: "💰" },
  { value: "handover_done",     label: "Handover Done by Me", icon: "↑"  },
  { value: "handover_received", label: "Handover Received",   icon: "↓"  },
  { value: "deposited_by_me",   label: "Deposited by Me",     icon: "🏦" },
];

var STATUS_OPTIONS = [
  { value: "",    label: "All Stages" },
  { value: "40",  label: "Cash Collected" },
  { value: "70",  label: "Handover Requested" },
  { value: "80",  label: "Handover Approved" },
  { value: "90",  label: "Deposit Requested" },
  { value: "100", label: "Bank Deposited" },
  { value: "110", label: "Reconciled" },
  { value: "55",  label: "Reversal Requested" },
  { value: "99",  label: "Reversed" },
];

var MODE_OPTIONS = [
  { value: "",               label: "All Modes" },
  { value: "Cash",           label: "Cash" },
  { value: "UPI",            label: "UPI" },
  { value: "Bank Transfer",  label: "Bank Transfer" },
  { value: "NACH",           label: "NACH" },
  { value: "Cheque",         label: "Cheque" },
];

var DEFAULT_FILTERS = { involvement: "all", status: "", collection_mode: "", start_date: "", end_date: "" };

function isDirty(draft) {
  return draft.involvement !== "all" || draft.status !== "" || draft.collection_mode !== "" ||
    draft.start_date !== "" || draft.end_date !== "";
}

export default function FilterDrawer({ visible, onClose, filters, onChange }) {
  // Local draft — initialised from parent filters each time the drawer opens
  var [draft, setDraft] = useState(filters || DEFAULT_FILTERS);

  useEffect(function() {
    if (visible) { setDraft(filters || DEFAULT_FILTERS); }
  }, [visible]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!visible) return null;

  function apply() {
    onChange(draft);
    onClose();
  }

  function clearAll() {
    var cleared = Object.assign({}, DEFAULT_FILTERS);
    setDraft(cleared);
    onChange(cleared);
    onClose();
  }

  function set(key, value) {
    setDraft(function(prev) { return Object.assign({}, prev, { [key]: value }); });
  }

  var dirty = isDirty(draft);

  return (
    <div className="tm-drawer-overlay" onClick={onClose}>
      <div className="tm-drawer" onClick={function(e) { e.stopPropagation(); }}>

        {/* Header */}
        <div className="tm-drawer__header">
          <span>Filters</span>
          <div className="tm-drawer__header-actions">
            {dirty && (
              <button className="tm-drawer__clear-btn" onClick={clearAll}>
                Clear All
              </button>
            )}
            <button className="tm-drawer__close" onClick={onClose}>×</button>
          </div>
        </div>

        {/* Involvement */}
        <div className="tm-drawer__section">
          <div className="tm-drawer__section-label">Involvement</div>
          <div className="tm-drawer__involvement">
            {INVOLVEMENT_OPTIONS.map(function(o) {
              return (
                <button
                  key={o.value}
                  className={"tm-involvement-btn" +
                    (draft.involvement === o.value ? " tm-involvement-btn--active" : "")}
                  onClick={function() { set("involvement", o.value); }}
                >
                  <span className="tm-involvement-btn__icon">{o.icon}</span>
                  <span>{o.label}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Stage / Status */}
        <div className="tm-drawer__section">
          <div className="tm-drawer__section-label">Stage</div>
          <select
            className="tm-drawer__select"
            value={draft.status}
            onChange={function(e) { set("status", e.target.value); }}
          >
            {STATUS_OPTIONS.map(function(o) {
              return (
                <option key={o.value} value={o.value}>{o.label}</option>
              );
            })}
          </select>
        </div>

        {/* Payment Mode */}
        <div className="tm-drawer__section">
          <div className="tm-drawer__section-label">Payment Mode</div>
          <select
            className="tm-drawer__select"
            value={draft.collection_mode}
            onChange={function(e) { set("collection_mode", e.target.value); }}
          >
            {MODE_OPTIONS.map(function(o) {
              return (
                <option key={o.value} value={o.value}>{o.label}</option>
              );
            })}
          </select>
        </div>

        {/* Date Range */}
        <div className="tm-drawer__section">
          <div className="tm-drawer__section-label">Date Range</div>
          <div style={{ display: "flex", gap: 8 }}>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 11, color: "#888", marginBottom: 4 }}>From</div>
              <input
                type="date"
                className="tm-drawer__select"
                value={draft.start_date}
                onChange={function(e) { set("start_date", e.target.value); }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 11, color: "#888", marginBottom: 4 }}>To</div>
              <input
                type="date"
                className="tm-drawer__select"
                value={draft.end_date}
                onChange={function(e) { set("end_date", e.target.value); }}
              />
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="tm-drawer__footer">
          <button className="tm-drawer__apply-btn" onClick={apply}>
            Apply Filters{dirty ? " ●" : ""}
          </button>
        </div>

      </div>
    </div>
  );
}

